import { render, staticRenderFns } from "./MyAside.vue?vue&type=template&id=dea81526&"
import script from "./MyAside.vue?vue&type=script&lang=js&"
export * from "./MyAside.vue?vue&type=script&lang=js&"
import style0 from "./MyAside.vue?vue&type=style&index=0&id=dea81526&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports